export default __webpack_public_path__ + "static/parallelLab-5f865d9869ac3ff48761c50b9afe9f08.jpg";